/** Best guess of the language/dialect a text is written in (used to reply — and speak — in the user's own dialect). */
const EGYPTIAN =
  /(?:ازاي|إزاي|ايه|إيه|دلوقتي|دلوقت|كده|كدا|عايز|عاوز|عاوزه|عايزه|مش |ده |دي |دول|بتاع|اللي|ليه|فين|امتى|إمتى|هات|هاتلي|اعمل|اعملي|شوف|خلي|يعني|طب |برضو|بردو|قوي|جدا|بقى|بقا|احنا|انا |انت |انتي)/;
const GULF = /(?:شلون|شنو|وش |ابغى|أبغى|ابي |زين|هالحين|وايد|حق )/;
const SAUDI = /(?:وش |ابغى|أبغى|يا شيخ|الحين|كذا |ابشر|أبشر|مره |مرة )/;
const LEVANT = /(?:شو |كيف حالك|هلق|هيك|بدي|منيح|كتير|ليش|هاد|شي )/;
const MAGHREB = /(?:بزاف|واش |دابا|ديال|كيفاش|فين غادي|نتا )/;

export type Detected =
  | "ar-eg"
  | "ar-sa"
  | "ar-gulf"
  | "ar-levant"
  | "ar-maghreb"
  | "ar-fusha"
  | "en"
  | "other"
  | null;

export function detectDialect(texts: string[]): Detected {
  const t = texts.join(" \n").trim();
  if (!t) return null;
  const arabic = (t.match(/[\u0600-\u06FF]/g) ?? []).length;
  const latin = (t.match(/[A-Za-z]/g) ?? []).length;
  if (arabic < 3 && latin < 3) return null;
  if (latin > arabic)
    return /\b(the|and|is|are|what|how|please|can|you)\b/i.test(t) ? "en" : "other";
  if (EGYPTIAN.test(t)) return "ar-eg";
  if (SAUDI.test(t)) return "ar-sa";
  if (GULF.test(t)) return "ar-gulf";
  if (LEVANT.test(t)) return "ar-levant";
  if (MAGHREB.test(t)) return "ar-maghreb";
  return "ar-fusha";
}
